<template>
  <div
    class="upload-file-container"
    :class="{
      hasError: errorStatus,
      uploadSuccesfully: fileAlreadyUpload,
    }"
  >
    <input
      :disabled="uploading"
      ref="input"
      class="example"
      type="file"
      accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
      @change="setFileData"
    />
    <div v-if="!fileAlreadyExist" class="upload-file-section">
      <div class="info-section" v-show="!errorMessage">
        {{ fileType }}: {{fileName ? fileName : '', }}
      </div>
      <div class="info-section errorMessage" v-show="errorMessage">
        {{ errorMessage }}
      </div>
      <div class="placeholder">
        <v-progress-circular
          indeterminate
          color="#008B52"
          v-show="uploading && !errorStatus"
        ></v-progress-circular>
        <v-icon
          large
          color="#008B52"
          class="logo"
          v-show="!uploading && fileAlreadyUpload"
        >
          mdi-check-bold
        </v-icon>
        <v-icon large color="red" class="logo" v-show="errorStatus">
          mdi-alert-circle-outline
        </v-icon>
      </div>
      <div class="buttons-container">
        <button
          @click="getRefFromInput"
          class="button selectButton"
          :disabled="uploading"
        >
          <v-icon medium color="#008B52" class="logo"> mdi-plus </v-icon>
          Agregar
        </button>
        <button
          @click="uploadFileToBucketGenerateLog"
          class="button uploadButton"
          :disabled="!file || uploading || fileAlreadyUpload || errorStatus"
        >
          <v-icon medium class="logo" color="white"> mdi-tray-arrow-up </v-icon>
          Subir
        </button>
      </div>
    </div>
    <div v-if="fileAlreadyExist" class="upload-file-section">
      <div class="info-section errorMessage">
        El archivo: {{ fileName }} ya existe, deseas reemplazarlo?
      </div>
      <div class="placeholder">
        <v-icon large color="red" class="logo" v-show="!uploading">
          mdi-alert-circle-outline
        </v-icon>
        <v-progress-circular
          indeterminate
          color="#008B52"
          v-show="uploading"
        ></v-progress-circular>
      </div>
      <div class="buttons-container">
        <button
          @click="getRefFromInput"
          class="button selectButton"
          :disabled="uploading"
        >
          <v-icon medium color="#008B52" class="logo"> mdi-plus </v-icon>
          Cambiar
        </button>
        <button
          @click="uploadFileToBucketGenerateLog"
          class="button uploadAgainButton"
          :disabled="!file || uploading || invalidDataFormat"
        >
          <v-icon medium color="red" class="logo">
            mdi-alert-circle-outline
          </v-icon>
          Subir
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import allowedFileNames from "../utils/allowedFileNames";
import generateErrorObject from "../utils/generateErrorObject";
import {
  getSignedUrl,
  generateFileLog,
  generateErrorLog,
} from "../utils/serverRequests";
import {
  verifyIfIsValidContractId,
  verifyIfIsValidPeriod,
  verifyIfIsValidYear,
} from "../utils/dataValidation";
import ExcelJS from "exceljs";
export default {
  name: "UploadFile",
  props: {
    fileType: String,
  },
  data() {
    return {
      file: null,
      fileName: null,
      errorStatus: false,
      errorMessage: "",
      fileAlreadyUpload: false,
      uploading: false,
      folder: null,
      fileAlreadyExist: false,
      fileLogId: null,
      route: null,
      invalidDataFormat: false,
      contractId: null,
      year: null,
      period: null,
      routeToReplaceFile: null,
    };
  },
  methods: {
    async verifyDataValidation(blob) {
      const contractCell = 1;
      const periodCell = 2;
      const yearCell = 3;
      let workbook = new ExcelJS.Workbook();
      await workbook.xlsx.load(blob);
      const worksheet = workbook.getWorksheet(1);
      const column = worksheet.getRow(2);
      this.contractId = column.getCell(contractCell).value;
      this.period = column.getCell(periodCell).value;
      this.year = column.getCell(yearCell).value;
      let isDataValidated = true;
      const dataValidation = [
        {
          name: "ID contrato",
          cellNumber: 1,
          value: await verifyIfIsValidContractId(
            this.contractId,
            this.$store.state.jwt
          ),
        },
        {
          name: "Periodo",
          cellNumber: 2,
          value: verifyIfIsValidPeriod(this.period),
        },
        {
          name: "Año",
          cellNumber: 3,
          value: verifyIfIsValidYear(this.year),
        },
      ];
      dataValidation.forEach((validation) => {
        if (!validation.value) {
          isDataValidated = false;
          return;
        }
      });
      return {
        isDataValidated,
        dataValidation,
      };
    },
    getRefFromInput() {
      this.$refs.input.click();
    },
    convertToBase64(file) {
      let reader = new FileReader();
      reader.onload = async (e) => {
        this.file = e.target.result;
      };
      reader.readAsDataURL(file);
    },
    setErrorStateTrue(error = "Ha ocurrido un error") {
      this.errorStatus = true;
      this.uploading = false;
      this.errorMessage = error;
    },
    getFolderFromFileName(filename) {
      const fileTypeRegex = /^([\w ]+)[-‐]{1}.*\.xlsx$/;
      const match = filename.match(fileTypeRegex);
      const errorMessageIfDontMatch = `El archivo: ${filename} no cumple el patrón requerido`;
      if (!match) {
        this.setErrorStateTrue(errorMessageIfDontMatch);
        return;
      }
      const fileCategory = match[1];
      if (allowedFileNames[fileCategory]) {
        this.folder = allowedFileNames[fileCategory];
      } else {
        this.setErrorStateTrue(errorMessageIfDontMatch);
      }
    },

    setFileData(e) {
      this.errorStatus = false;
      this.invalidDataFormat = false;
      this.errorMessage = null;
      this.route = null;
      this.fileAlreadyUpload = false;
      this.fileAlreadyExist = false;
      let file = e.target.files[0];
      if (file) {
        this.fileName = file.name.toLowerCase();
        this.getFolderFromFileName(this.fileName);
        this.convertToBase64(file);
      } else {
        this.file = null;
        this.fileName = null;
      }
    },
    async uploadFileToBucketGenerateLog() {
      if (!this.file || !this.folder)
        return;
      const base64Response = await fetch(this.file);
      let blob = await base64Response.blob();
      if (!blob) return;
      this.uploading = true;
      const isDataFormated = await this.verifyDataValidation(blob);
      if (!isDataFormated.isDataValidated) {
        this.invalidDataFormat = true;
        let cellsWithErrorsName = [];
        isDataFormated.dataValidation.forEach((validation) => {
          if (!validation.value) {
            cellsWithErrorsName.push(validation.name);
          }
        });
        this.setErrorStateTrue(
          `Error: Valores inválidos en celdas: ${cellsWithErrorsName.join(
            ", "
          )}`
        );
        return;
      }
      const params = {
        filename: this.fileName,
        folder: this.folder,
        replaceFile: this.fileAlreadyExist,
        contractId: this.contractId,
        period: this.period,
        year: this.year,
        route: this.routeToReplaceFile,
      };
      getSignedUrl(params, this.$store.state.jwt)
        .then(async (response) => {
          if (response.data.signedUrl) {
            this.route = response.data.key;
            await this.uploadToBucketProccess(blob, response.data.signedUrl);
          }
        })
        .catch(async (error) => {
          if (error.response.data.fileAlreadyExistWarning) {
            this.setErrorStateTrue();
            (this.fileAlreadyExist = true),
              (this.routeToReplaceFile = error.response.data.route);
            this.fileLogId = error.response.data.fileLogId;
          } else {
            await this.generateErrorLogProccess(error);
          }
        });
    },
    async generetaFileLogProccess(body, token) {
      generateFileLog(body, token)
        .then(() => {
          this.fileAlreadyUpload = true;
          this.uploading = false;
          this.errorStatus = false;
          this.errorMessage = null;
          this.fileAlreadyExist = false;
          this.fileLogId = null;
          this.route = null;
        })
        .catch((error) => {
          this.generateErrorLogProccess(error);
        });
    },
    async generateErrorLogProccess(error) {
      const { status } = error.response;
      const { message, userMessage, createLog } = error.response.data;
      const errorBody = generateErrorObject(
        this.$store.state.userData._id,
        status,
        message,
        userMessage,
        this.fileName
      );
      this.setErrorStateTrue(userMessage);
      if (createLog) {
        return generateErrorLog(errorBody);
      }
    },
    async uploadToBucketProccess(blob, signedUrl) {
      this.uploadToBucketHttpRequest(blob, signedUrl)
        .then(async (response) => {
          if (response.status == 200) {
            const body = {
              id: this.$store.state.userData._id,
              filename: this.fileName,
              fileLogId: this.fileLogId,
              route: this.route,
              username: this.$store.state.userData.username,
            };
            await this.generetaFileLogProccess(body, this.$store.state.jwt);
          } else {
            this.setErrorStateTrue();
          }
        })
        .catch((error) => {
          this.generateErrorLogProccess(error);
        });
    },
    async uploadToBucketHttpRequest(blob, endpoint) {
      const config = {
        method: "PUT",
        url: `${endpoint}`,
        data: blob,
      };
      return axios(config);
    },
  },
};
</script>

<style scoped>
.uploadAgainButton {
  color: red;
  background: white;
  border: 2px solid red;
}
p {
  box-sizing: border-box;
}
.button {
  width: 30%;
  min-width: 95px;
  height: 40px;
  min-height: auto;
  margin: 0 0px;
  transition: transform 0.3s;
  border-radius: 7px;
}
.button:active {
  transform: scale(0.9);
}
.placeholder {
  align-self: center;
}
.selectButton {
  border: 2px solid #008b52;
  color: #008b52;
}
.uploadButton {
  background: #008b52;
  color: white;
}
.upload-file-container {
  display: flex;
  height: 100%;
  min-height: 175px;
  max-height: 225px;
  width: 100%;
  max-width: 100%;
  border: 1px solid rgba(0, 0, 0, 0.15);
  border-radius: 20px;
  align-items: center;
  align-items: center;
  padding: 20px 20px;
}
.upload-file-section {
  display: flex;
  height: 100%;
  width: 100%;
  flex-direction: column;
  align-items: center;
  align-items: flex-start;
  justify-content: space-between;
}
.hasError {
  border: 2px solid red;
}
.uploadSuccesfully {
  border: 2px solid #008b52;
}
.example {
  display: none;
}
.custom-file-upload {
  border: 1px solid #ccc;
  padding: 6px 12px;
  cursor: pointer;
  vertical-align: middle;
}
.buttons-container {
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-around;
}
.info-section {
  max-width: 100%;
}
.errorMessage {
  color: red;
}
</style>

